import React, { useEffect, useState } from "react";
import { Input, Modal } from "reactstrap";
import { formatModifyDate } from "../../../components/Common/CommonLogic";
import Select from "react-select";
import { useSelector } from "react-redux";
import { BOOKING_STATUS, CUST_APPRVD_PENDING } from "../../Dashboard/Partials/initialData";
import { useDispatch } from "react-redux";
import { bookingStatusRequest } from "../../../store/Sales/actions";
import { showErrorToast, showSuccessToast } from "../../../components/Common/CustomToast";
import { BOOKINGS_STATUS_INIT } from "../../../store/Sales/actiontype";

const BookingAction = ({ actionOpen, setActionOpen, quotationData, actionType, locationFrom, onRefresh }) => {
    const [cancelReason, setCancelReason] = useState("");
    const [remarks, setRemarks] = useState("");
    const [reasonError, setReasonError] = useState("");
    const [cargoDate, setCargoDate] = useState([]);
    const { reason_master, status_master } = useSelector(state => state?.globalReducer);
    const { getBookingStatusLoader, getBookingStatusUpdateSuccess, getBookingStatusUpdateFail, getBookingStatusFailData } = useSelector((state) => state?.sales);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch({ type: BOOKINGS_STATUS_INIT });
        const cargoDateSplit = typeof quotationData?.cargoDate === "string" ? quotationData?.cargoDate.split('/') : [];
        setCargoDate(cargoDateSplit);
    }, [quotationData])

    const agentBookingAccept = () => {
        let payload = {
            "remarks": remarks,
            "statusId": status_master?.find((item) => item?.statusCode === BOOKING_STATUS.BOOKING_ACCEPTED)?.id,
            "inquiryId": quotationData?.inquiryId,
            "reasonId": null,
            "quotationId": quotationData?.quotationId,
            "bookingSummeryId": quotationData?.bookingSummeryId,
        }
        dispatch(bookingStatusRequest(payload));
        setTimeout(() => {
            onRefresh();
            setActionOpen(false);
        }, 200);
    }

    const agentBookingReject = () => {
        // Validate reason field
        if (!cancelReason || !cancelReason?.id) {
            setReasonError("Please select a reason for rejection");
            return;
        }
        
        setReasonError(""); // Clear error if validation passes
        
        let payload = {
            "remarks": remarks,
            "statusId": status_master?.find((item) => item?.statusCode === BOOKING_STATUS.BOOKING_REJECTED)?.id,
            "inquiryId": quotationData?.inquiryId,
            "reasonId": cancelReason?.id,
            "quotationId": quotationData?.quotationId,
            "bookingSummeryId": quotationData?.bookingSummeryId,
        }
        dispatch(bookingStatusRequest(payload));
        setTimeout(() => {
            onRefresh();
            setActionOpen(false);
        }, 200);
    }

    const shipperBookingAccept = () => {
        let payload = {
            "remarks": remarks,
            "statusId": status_master?.find((item) => item?.statusCode === BOOKING_STATUS.CUST_APPRVD)?.id,
            "inquiryId": quotationData?.inquiryId,
            "reasonId": null,
            "quotationId": quotationData?.quotationId,
            "bookingSummeryId": quotationData?.bookingSummeryId,
        }
        dispatch(bookingStatusRequest(payload));
        setTimeout(() => {
            onRefresh();
            setActionOpen(false);
        }, 200);
    }

    const shipperBookingReject = () => {
        // Validate reason field
        if (!cancelReason || !cancelReason?.id) {
            setReasonError("Please select a reason for rejection");
            return;
        }
        
        setReasonError(""); // Clear error if validation passes
        
        let payload = {
            "remarks": remarks,
            "statusId": status_master?.find((item) => item?.statusCode === BOOKING_STATUS.CUST_REJECT)?.id,
            "inquiryId": quotationData?.inquiryId,
            "reasonId": cancelReason?.id,
            "quotationId": quotationData?.quotationId,
            "bookingSummeryId": quotationData?.bookingSummeryId,
        }
        dispatch(bookingStatusRequest(payload));
        setTimeout(() => {
            onRefresh();
            setActionOpen(false);
        }, 200);
    }

    useEffect(() => {
        //console.log(getBookingStatusUpdateSuccess, 'getBookingStatusUpdateSuccess')
        if (getBookingStatusUpdateSuccess) {
            dispatch({ type: BOOKINGS_STATUS_INIT });
            setActionOpen(false);
            showSuccessToast('Status Updated Successfully');
        }
    },[getBookingStatusUpdateSuccess]);

    useEffect(() => {
        if (getBookingStatusUpdateFail) {
            //console.log(getBookingStatusFailData);
            showErrorToast(getBookingStatusFailData);
        }
    },[getBookingStatusUpdateFail]);



    return (
        <>
            <Modal
                isOpen={actionOpen}
                toggle={() => {
                    setActionOpen(false);
                }}
                centered={true}
            >
                <div className="modal-header">
                    <h5 className="modal-title mt-0">Booking Id #{quotationData?.bookingSummeryId}</h5>
                    <button
                        type="button"
                        onClick={() => {
                            setActionOpen(false);
                        }}
                        className="close"
                        data-dismiss="modal"
                        aria-label="Close"
                    >
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div className="modal-body">
                    {actionType === 'accept' && locationFrom === 'bookingLead' && (
                        <>
                            <h5>Are you sure you want to confirm this freight booking?</h5>
                            <div className="mb-3">
                                <h6 className="text-primary mb-3">Booking Summary</h6>
                                <ul className="list-group mb-3">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>From:</span>
                                        <strong>{quotationData?.originPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>To:</span>
                                        <strong>{quotationData?.destinationPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Freight Type:</span>
                                        <strong>{quotationData?.rateType?.replace("_", " ")}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Pickup Date:</span>
                                        <strong>{formatModifyDate(cargoDate[0])}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Estimated Delivery:</span>
                                        <strong>{formatModifyDate(cargoDate[1])}</strong>
                                    </li>
                                </ul>
                                <div className="alert alert-warning d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="bell" className="me-2">🔔</span>
                                    Once confirmed: The booking request will be submitted to the operations team.
                                </div>
                                <div className="alert alert-info d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="mail" className="me-2">📩</span>
                                    A confirmation message will be sent to the shipper as an acknowledgment.
                                </div>
                                <div className="text-danger mt-3">
                                    <strong>Please verify all details before proceeding.</strong>
                                </div>
                                <div className="mt-2 mb-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Please provide remarks:
                                    </label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {actionType === 'reject' && locationFrom === 'bookingLead' && (
                        <>
                            <h5 className="text-danger">Are you sure you want to cancel this freight booking request?</h5>
                            <div className="mb-3">
                                <h6 className="text-primary mb-3">Booking Summary</h6>
                                <ul className="list-group mb-3">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>From:</span>
                                        <strong>{quotationData?.originPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>To:</span>
                                        <strong>{quotationData?.destinationPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Freight Type:</span>
                                        <strong>{quotationData?.rateType?.replace("_", " ")}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Pickup Date:</span>
                                        <strong>{formatModifyDate(cargoDate[0])}</strong>
                                    </li>
                                </ul>
                                <div className="alert alert-danger d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="warning" className="me-2">❗</span>
                                    Once cancelled: The booking will be marked as cancelled in the system.
                                </div>
                                <div className="alert alert-info d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="mail" className="me-2">📩</span>
                                    A cancellation message will be sent to the shipper.
                                </div>
                                <div className="text-danger mt-3">
                                    <strong>This action cannot be undone.</strong>
                                </div>
                                <div className="mt-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Please provide a reason for cancellation:
                                    </label>
                                    <Select
                                        name="reason"
                                        options={reason_master}
                                        value={cancelReason}
                                        onChange={(reason) => {setCancelReason(reason); setReasonError("");}}
                                        classNamePrefix="select2-selection form-select"
                                    />
                                    {reasonError && <div className="text-danger">{reasonError}</div>}
                                </div>
                                <div className="mt-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Please provide remarks:
                                    </label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {actionType === 'accept' && locationFrom === 'mybooking' && (
                        <>
                            <h5>🔄 Approve Updated Quotation</h5>
                            <div className="mb-3">
                                <h6 className="text-primary mb-3">The quotation has been updated by the agent.</h6>
                                <p>Please review the changes below and confirm to proceed.</p>
                                <h6>📋 Quotation Summary:</h6>
                                <ul className="list-group mb-3">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Quotation ID:</span>
                                        <strong>{quotationData?.quotationId}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Origin:</span>
                                        <strong>{quotationData?.originPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Destination:</span>
                                        <strong>{quotationData?.destinationPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Freight Type:</span>
                                        <strong>{quotationData?.rateType?.replace("_", " ")}</strong>
                                    </li>
                                </ul>
                                <div className="alert alert-warning d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="bell" className="me-2">📩</span>
                                    Once approved, the updated quotation will be locked in and forwarded for booking.
                                </div>
                                <div className="mt-2 mb-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Please provide remarks:
                                    </label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                    {actionType === 'reject' && locationFrom === 'mybooking' && (
                        <>
                            <h5 className="text-danger">❌ Reject Updated Quotation</h5>
                            <div className="mb-3">
                                <p>You are about to reject the updated quotation provided by the agent.</p>
                                <p>Please review the quotation details and provide a reason for rejection.</p>
                                <h6>📋 Quotation Summary:</h6>
                                <ul className="list-group mb-3">
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Quotation ID:</span>
                                        <strong>{quotationData?.quotationId}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Origin:</span>
                                        <strong>{quotationData?.originPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Destination:</span>
                                        <strong>{quotationData?.destinationPortName}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Freight Type:</span>
                                        <strong>{quotationData?.rateType?.replace("_", " ")}</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Updated Rate:</span>
                                        <strong>-</strong>
                                    </li>
                                    <li className="list-group-item d-flex justify-content-between align-items-center">
                                        <span>Remarks from Agent:</span>
                                        <strong>-</strong>
                                    </li>
                                </ul>
                                <div className="alert alert-danger d-flex align-items-center" role="alert">
                                    <span role="img" aria-label="warning" className="me-2">📨</span>
                                     A rejection notification will be sent to the agent along with your reason.
                                </div>
                                <div className="mt-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Reason for Rejection: (required)
                                    </label>
                                    <Select
                                        name="reason"
                                        options={reason_master}
                                        value={cancelReason}
                                        onChange={(reason) => {setCancelReason(reason); setReasonError("");}}
                                        classNamePrefix="select2-selection form-select"
                                    />
                                    {reasonError && <div className="text-danger">{reasonError}</div>}
                                </div>
                                <div className="mt-4 mb-4">
                                    <label htmlFor="cancelReason" className="form-label">
                                        📝 Please provide remarks:
                                    </label>
                                    <Input
                                        type="textarea"
                                        name="remarks"
                                        value={remarks}
                                        onChange={(e) => setRemarks(e.target.value)}
                                        className="form-control"
                                    />
                                </div>
                            </div>
                        </>
                    )}

                </div>
                <div className="modal-footer">
                    {actionType === 'accept' && locationFrom === 'bookingLead' && (
                        <button type="button" className="btn btn-primary" onClick={agentBookingAccept} disabled={getBookingStatusLoader}>
                            Confirm
                        </button>
                    )}
                    {actionType === 'reject' && locationFrom === 'bookingLead' && (
                        <button type="button" className="btn btn-primary" onClick={agentBookingReject} disabled={getBookingStatusLoader}>
                            Confirm
                        </button>
                    )}
                    {actionType === 'accept' && locationFrom === 'mybooking' && (
                        <button type="button" className="btn btn-primary" onClick={shipperBookingAccept} disabled={getBookingStatusLoader}>
                            Confirm
                        </button>
                    )}
                    {actionType === 'reject' && locationFrom === 'mybooking' && (
                        <button type="button" className="btn btn-primary" onClick={shipperBookingReject} disabled={getBookingStatusLoader}>
                            Confirm
                        </button>
                    )}
                    <button
                        type="button"
                        className="btn btn-secondary"
                        data-dismiss="modal" onClick={() => setActionOpen(false)}>
                        Close
                    </button>
                </div>
            </Modal>
        </>
    )
}


export default BookingAction;